import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2464_63814)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.6739 7.95719L5.88743 1.17087C5.73047 1.01379 5.52094 0.927246 5.29752 0.927246C5.0741 0.927246 4.86457 1.01379 4.70761 1.17087L4.20784 1.67052C3.88263 1.9961 3.88263 2.52526 4.20784 2.85034L9.90658 8.54908L4.20151 14.2542C4.04455 14.4112 3.95789 14.6206 3.95789 14.8439C3.95789 15.0675 4.04455 15.2769 4.20151 15.4341L4.70129 15.9336C4.85837 16.0907 5.06778 16.1772 5.2912 16.1772C5.51461 16.1772 5.72414 16.0907 5.88111 15.9336L12.6739 9.1411C12.8312 8.98352 12.9176 8.77312 12.9171 8.54946C12.9176 8.32492 12.8312 8.11465 12.6739 7.95719Z",
    fill: "white"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2464_63814" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "15.25",
      height: "15.25",
      fill: "white",
      transform: "translate(0.8125 0.927246)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }